import { createQuery } from '@tanstack/svelte-query';
import { QUERY_KEY_USER_DATA, QUERY_KEY_USER_PROFILE } from '../constants';
import { client } from '../lib/client';

export const getUserData = async () => {
  const response = await client.get(`/api/user/me`);
  return response.data;
};

export const getUserDataQuery = {
  queryKey: [QUERY_KEY_USER_DATA],
  queryFn: getUserData,
  staleTime: Infinity,
};

export const getUserProfile = async () => {
  const response = await client.get('/api/user/profile');
  return response.data;
};

export const queryUserProfileQuery = () =>
  createQuery({
    queryKey: [QUERY_KEY_USER_PROFILE],
    queryFn: getUserProfile,
    staleTime: Infinity,
  });

export const updateUserProfile = async (profileData) => {
  const response = await client.patch('/api/creator/me/profile', profileData);
  return response.data;
};
